import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { getMyLocations } from '../lib/api';

const PortalLocationContext = createContext();

export const PortalLocationProvider = ({ children }) => {
  const { user } = useAuth();
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && (user.role === 'location_user' || user.role === 'location_employee' || user.role === 'partner')) {
      loadLocations();
    }
  }, [user]);

  const loadLocations = async () => {
    setLoading(true);
    try {
      const res = await getMyLocations();
      const locs = res.data || [];
      setLocations(locs);
      
      // Try to restore previously selected location from localStorage
      const savedLocationId = localStorage.getItem('portal_selected_location');
      const savedLocation = locs.find(l => l.id === savedLocationId);
      
      if (savedLocation) {
        setSelectedLocation(savedLocation);
      } else if (locs.length > 0) {
        setSelectedLocation(locs[0]);
        localStorage.setItem('portal_selected_location', locs[0].id);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const selectLocation = (location) => {
    setSelectedLocation(location);
    localStorage.setItem('portal_selected_location', location.id);
  };

  return (
    <PortalLocationContext.Provider value={{
      locations,
      selectedLocation,
      selectLocation,
      loading,
      refreshLocations: loadLocations
    }}>
      {children}
    </PortalLocationContext.Provider>
  );
};

export const usePortalLocation = () => {
  const context = useContext(PortalLocationContext);
  if (!context) {
    throw new Error('usePortalLocation must be used within a PortalLocationProvider');
  }
  return context;
};
